/** @format */

/**
 * Persisted super-admin impersonation context. Stored in localStorage so an
 * active impersonation survives a full page refresh (Redux state is not
 * persisted). Written when a super admin opens a business from the admin
 * console and cleared on exit.
 */
export const IMPERSONATION_STORAGE_KEY = "collect_impersonation";

export interface StoredImpersonation {
    businessId: string;
    businessName: string;
}

export function readStoredImpersonation(): StoredImpersonation | null {
    try {
        const raw = window.localStorage.getItem(IMPERSONATION_STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed.businessId === "string") {
            return {
                businessId: parsed.businessId,
                businessName:
                    typeof parsed.businessName === "string"
                        ? parsed.businessName
                        : "",
            };
        }
        return null;
    } catch {
        return null;
    }
}

export function clearStoredImpersonation(): void {
    try {
        window.localStorage.removeItem(IMPERSONATION_STORAGE_KEY);
    } catch {
        /* no-op */
    }
}
